import axios      from 'axios';
import { mutate } from 'swr';

import { getError }                 from '@shared/utils/helpers';
import { Notistack }                from '@shared/components/Notistack/Notistack';
import { SERVICES }                 from '@shared/constants/apiConfig';
import { ILeadSourceConfiguration } from './LeadSourceConfiguration';

const path = `/${SERVICES.LEAD}`;

export const requestCreateLeadSource = (data: ILeadSourceConfiguration) => {
  return mutate(path, async() => {
    try {
      await axios.post(`${path}/source`, data);
      Notistack.successMessage('Lead Source Configuration - Created Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
      throw err;
    }
  });
};

export const requestUpdateLeadSource = (data: ILeadSourceConfiguration) => {
  return mutate(path, async() => {
    try {
      await axios.put(`${path}/source/${data?.id}`, data);
      Notistack.successMessage('Lead Source Configuration - Updated Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
      throw err;
    }
  });
};

export const requestDeleteLeadSource = (id: string) => {
  return mutate(path, async() => {
    try {
      await axios.delete(`${path}/source/${id}`);
      Notistack.successMessage('Lead Source Configuration - Deleted Successfully');
    } catch (err) {
      const error = err as { response: { data: { message: string } } };
      Notistack.generalError(error?.response?.data?.message);
    }
  });
};
